import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthStyle } from "./Auth.styled";
import ROUTE from "../../../common/Routes";
import { useDispatch } from "react-redux";
import { setUserName, setUserRole } from "../../../redux/roles/userRoleSlice";
import { toast } from "react-toastify";
import { LoginValidationSchema } from "../../../validations/LoginValidation";
import { useDB } from "../../../context/DynamoDBContext";
import {
  setToken,
  setUserAccessKey,
  setUserSecretKey,
} from "../../../redux/roles/userApiSlice";
import { persistor } from "../../../redux/reduxStore";
import api from "../../../api/configAxios";
import Footer from "../../../components/footer/Footer";
import Controller from "../../../common/controller";
import { TextErrorStyle } from "../../../styles/ErrorStyles";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [btnText, setBtnText] = useState("Login");
  const [loginBtnEnable, setLoginBtnEnable] = useState(false);

  const { setDBClient } = useDB();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      clearData();
    }, 50);
  }, []);

  const clearData = async () => {
    await persistor
      .purge()
      .then((res) => {})
      .catch((err) => console.error(err));
  };

  const Errors = (err) => {
    err.forEach((element) => {
      switch (element.split(":")[0]) {
        case "1":
          setEmailErr(element.split(":")[1]);
          break;
        case "2":
          setPasswordErr(element.split(":")[1]);
          break;
        default:
          setError(true);
          setErrorText("An Error has occured in validation");
          break;
      }
    });
  };

  const checkUser = async () => {
    handleAuth();
  };

  const login = (item) => {
    console.log("Login item:", item.roleId);
    dispatch(setUserRole(item?.roleId));
    dispatch(setUserName(`${item?.firstName} ${item?.lastName}`));
    toast("Login Sucessfull");
    navigate(ROUTE.Home);
  };

  async function handleAuth() {
    try {
      var response = await api.post(`${Controller.dynamoDB}/Login`, {
        email: email.toLocaleLowerCase(),
        password: password,
      });
      const data = response.data;
      if (typeof data === "string") {
        setError(true);
        setBtnText("Login");
        setLoginBtnEnable(false);
        setErrorText(data);
        return;
      }
      console.log("Login response:", data);
      setDBClient(data.secretKey, data.accessKey);
      dispatch(setUserSecretKey(data.secretKey));
      dispatch(setUserAccessKey(data.accessKey));
      dispatch(setToken(data.access_Token));

      login(data);
    } catch (error) {
      setError(true);
      setBtnText("Login");
      setLoginBtnEnable(false);
      setErrorText("Internal Server Error");
      return;
    }
    return;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoginBtnEnable(true);
    setBtnText("Loading...");
    const formData = {
      email,
      password,
    };

    await LoginValidationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        checkUser();
      })
      .catch((err) => {
        setBtnText("Log in");
        setLoginBtnEnable(false);
        Errors(err.errors);
      });
  };

  return (
    <AuthStyle>
      <div className="body">
        <div className="container-1">
          <img src={"ocufii_rev_mark.png"} className="img-logo" alt="Ocufii" />
          <h1 className="description">
            Bringing smart innovation to the firearms industry!
          </h1>
        </div>
        <div className="container-2">
          <div className="login-container">
            {/* <img src='logo.png' className='app-logo' alt="logo" /> */}
            <h1 className="text-login">Login</h1>
            <form onSubmit={handleSubmit} className="form-container">
              <label className="form-text" htmlFor="email">
                Email
              </label>
              <br />
              <input
                type="email"
                id="email"
                maxLength={30}
                placeholder="Enter Email"
                className={
                  emailErr !== ""
                    ? "form-control mt-1 error-input"
                    : "form-control mt-1 input-field"
                }
                value={email}
                onChange={(e) => {
                  setEmailErr("");
                  setError(false);
                  setErrorText("");
                  setEmail(e.target.value);
                }}
              />
              {emailErr !== "" ? (
                <TextErrorStyle>{emailErr}</TextErrorStyle>
              ) : (
                <p className="text-errorfade">abc</p>
              )}

              <label className="form-text" htmlFor="password">
                Password
              </label>
              <input
                type="password"
                id="password"
                maxLength={30}
                placeholder="Enter Password"
                className={
                  passwordErr !== ""
                    ? "form-control mt-1 error-input"
                    : "form-control mt-1 input-field"
                }
                value={password}
                onChange={(e) => {
                  setPasswordErr("");
                  setError(false);
                  setErrorText("");
                  setPassword(e.target.value);
                }}
              />
              {passwordErr !== "" ? (
                <TextErrorStyle>{passwordErr}</TextErrorStyle>
              ) : (
                <p className="text-errorfade">abc</p>
              )}

              <div className="btn-container">
                <button
                  type="submit"
                  className={
                    loginBtnEnable
                      ? "btn form-button form-button-disable"
                      : "btn form-button"
                  }
                  disabled={loginBtnEnable}
                >
                  {btnText}
                </button>
              </div>
            </form>
            {error ? (
              <p className="text-error2">{errorText}</p>
            ) : (
              <p className="text-errorfade">abc</p>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </AuthStyle>
  );
};

export default Auth;
